import { FC, PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import { useTypedTranslationsWithPartialResult } from '~/components/translation/use-translations';
import textKeyIsSet from '~/utils/textkey-is-set';

type CasinoSeoHeaderProps = PropsWithChildren<{
	titleTextKey: string;
	descriptionTextKey: string;
	keywordsTextKey: string;
}>;

const CasinoSeoHeader: FC<CasinoSeoHeaderProps> = ({ titleTextKey, descriptionTextKey, keywordsTextKey, children }) => {
	const typedTranslations = useTypedTranslationsWithPartialResult({
		titleTextKey,
		descriptionTextKey,
		keywordsTextKey
	});

	const siteTitle = typedTranslations.translations[titleTextKey];
	const description = typedTranslations.translations[descriptionTextKey];
	const keywords = typedTranslations.translations[keywordsTextKey];

	return (
		<Helmet>
			{textKeyIsSet(siteTitle) && <title>{siteTitle}</title>}
			{textKeyIsSet(description) && <meta name="description" content={description} />}
			{textKeyIsSet(keywords) && <meta name="keywords" content={keywords} />}
			{children}
		</Helmet>
	);
};

export default CasinoSeoHeader;
